module.exports = __webpack_public_path__ + "img/icon_dowland.60a47038.png";